import buildRequest from '@/utils/utils';

export const getVotePagesEndpoint = (accountId: string) => buildRequest(`/api/v1/accounts/${accountId}/vote-pages`);

export const getNomineesEndpoint = (votePageId: string) => buildRequest(`/api/v1/vote-pages/${votePageId}/nominees`);

export const getCategoriesEndpoint = (votePageId: string) =>
  buildRequest(`/api/v1/vote-pages/${votePageId}/categories`);

export const postLoginAccountEndpoint = (account: string, password: string) =>
  buildRequest('/api/v1/auth/account', 'post', { account, password }, { withCredentials: true });

export const postLogoutEndpoint = () =>
  buildRequest('/api/v1/auth/account/logout', 'post', undefined, { withCredentials: true });

export const postRefreshTokenEndpoint = () =>
  buildRequest('/api/v1/auth/account/refresh', 'post', undefined, { withCredentials: true });

export const postSignUpEndpoint = (data: { name: string; email: string; password: string }) =>
  buildRequest('/api/v1/accounts', 'post', data, { withCredentials: true });

export const postGoogleSignInEndpoint = (credential: string) =>
  buildRequest('/api/v1/auth/account/google', 'post', { credential }, { withCredentials: true });

export const deleteAccountEndpoint = (accountId: string, { password, reason }: { password: string; reason: string }) =>
  buildRequest(`/api/v1/accounts/${accountId}`, 'delete', { password, reason });

export const postCreateVotePageEndpoint = (data: { vote_type: string; vote_method: string; name: string }) =>
  buildRequest(`/api/v1/vote-pages`, 'post', data);

export const postInitiatePasswordResetEndpoint = (account: string) =>
  buildRequest('/api/v1/auth/account/initiate-password-reset', 'post', { account });

// The token travels in the body, not the path, so it stays out of access logs.
export const postVerifyEmailChangeEndpoint = (token: string) =>
  buildRequest('/api/v1/accounts/email-change/verify', 'post', { token });

export const postDeclineEmailChangeEndpoint = (token: string) =>
  buildRequest('/api/v1/accounts/email-change/decline', 'post', { token });

export const postConfirmEmailChangeEndpoint = (token: string) =>
  buildRequest('/api/v1/accounts/email-change/confirm', 'post', { token });

export const getVoteTrendEndpoint = (votePageId: string) =>
  buildRequest(`/api/v1/votes/trend?vote_page_id=${votePageId}`);

export const patchVotePageCanNominateEndpoint = (votePageId: string, canNominate: boolean) =>
  buildRequest(`/api/v1/vote-pages/${votePageId}/can-nominate`, 'patch', { can_nominate: canNominate });

export const getVotePageResults = (votePageId: string, since: string | null) =>
  buildRequest(`/api/v1/vote-pages/${votePageId}/results`, 'get', undefined, { params: { since } });

export const getTotalVotesEndpoint = (accountId: string) => buildRequest(`/api/v1/accounts/${accountId}/total-votes`);

export const getVotesHistoryEndpoint = (accountId: string) =>
  buildRequest(`/api/v1/accounts/${accountId}/votes-history`);

export const getNominationFormEndpoint = (votePageId: string) =>
  buildRequest(`/api/v1/vote-pages/${votePageId}/nomination-form`);

export const putNominationFormEndpoint = (votePageId: string, form: unknown[], description: string) =>
  buildRequest(`/api/v1/vote-pages/${votePageId}/nomination-form`, 'put', { form, description });
